import { ScreenType, useScreenType } from '@/utils/ScreenUtils'

const ViewableStoriesByScreenType: Record<ScreenType, number> = {
  [ScreenType.mobile]: 3,
  [ScreenType.mobileplus]: 6,
  [ScreenType.tablet]: 2,
  [ScreenType.desktop]: 3,
}

export const useViewableStoriesConfig = (storyCount: number) => {
  const screenType = useScreenType() || ScreenType.mobile

  const viewableCount = ViewableStoriesByScreenType[screenType]
  const remainingCount = storyCount - viewableCount <= 0 ? 0 : storyCount - viewableCount

  return {
    viewableCount,
    remainingCount,
  }
}
